import CardHeader from '@mui/material/CardHeader';
import React from 'react';
import { getUser } from '../../helpers/token';
import Link from '@mui/material/Link';
import RoundNavIconBtn from '../Header/RoundNavIconBtn';
import ProfileAvatar from '../Profile/ProfileAvatar';
import ProfileName from '../Profile/ProfileName';
import DotMenu from './DotMenu';
import SubHeader from './SubHeader';

const PostContent = props => {
  return (
    <>
      <CardHeader
        avatar={
          !props.hideHeader && (
            <Link href={`/@${props.author.username}`}>
              <RoundNavIconBtn style={{ padding: 0 }}>
                <ProfileAvatar
                  authorAvatar={props.authorAvatar}
                  author={props.author.username}
                />
              </RoundNavIconBtn>
            </Link>
          )
        }
        action={
          props.hideDots ? (
            <></>
          ) : (
            <>
              <DotMenu
                editLink={
                  getUser() === props.author.username
                    ? `/dashboard/publish?permlink=${encodeURIComponent(
                        props.permlink,
                      )}`
                    : undefined
                }
                author={props.author.username}
                permlink={props.permlink}
                title={props.title}
                thumbnail={props.thumbnail}
                tags={props.tags}
              />
            </>
          )
        }
        title={
          !props.hideHeader && (
            <ProfileName
              author={props.author}
              authorNotClickable={props.authorNotClickable}
            />
          )
        }
        subheader={
          !props.hideHeader && (
            <SubHeader
              showWordCount={props.showWordCount}
              createdAt={props.createdAt ? String(props.createdAt) : undefined}
              readTime={props.readTime}
              wordCount={props.wordCount}
              location={props.location}
              community={props.community}
            />
          )
        }
      />
      {props.isIntro && (
        <div className="bg-warning">
          This post uses #introduceyourself. Please verify that it actually is
          the user&apos;s first post, otherwise blacklist.
        </div>
      )}
      {props.content}
    </>
  );
};

export default PostContent;
